export default __webpack_public_path__ + "static/media/logo-white.cf9143d2.svg";